import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=07194b17&"
import script from "./ReservationList.ts?vue&type=script&lang=js&"
export * from "./ReservationList.ts?vue&type=script&lang=js&"
import style0 from "./ReservationList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports